// extracted by mini-css-extract-plugin
export var border = "_s-8";
export var brand = "_s-t";
export var button = "_s-l";
export var center = "_s-a";
export var centered = "_s-6";
export var closeButton = "_s-c";
export var disabledWrapper = "_s-m";
export var error = "_s-p";
export var extraLarge = "_s-4";
export var extraSmall = "_s-1";
export var fill = "_s-i";
export var footer = "_s-h";
export var footerAction = "_s-j";
export var footerButtons = "_s-k";
export var header = "_s-7";
export var headerWithClose = "_s-d";
export var icon = "_s-o";
export var info = "_s-s";
export var inline = "_s-9";
export var large = "_s-3";
export var main = "_s-e";
export var modal = "_s-0";
export var nearFull = "_s-5";
export var neutral = "_s-u";
export var noPadding = "_s-g";
export var none = "_s-v";
export var scrollable = "_s-f";
export var small = "_s-2";
export var success = "_s-r";
export var tight = "_s-n";
export var titleIcon = "_s-b";
export var warn = "_s-q";